var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import mediaQueries from "syf-component-library/const/mediaQueries";
import Select from "syf-component-library/ui/atoms/Select";
var AccountDropDown = styled(Select)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  @media ", " {\n    max-width: 942px;\n  }\n"], ["\n  ", "\n  @media ", " {\n    max-width: 942px;\n  }\n"])), function (_a) {
    var isTablet = _a.isTablet;
    return isTablet && "min-width: 105px;";
}, mediaQueries.greaterThanMedium);
export default AccountDropDown;
var templateObject_1;
